module.exports = __webpack_public_path__ + "media/images/circle-checked-f2dfcd1f3a1571278777508176a6ee42.svg";